import React from "react";
import { Miniloader } from "../../Miniloader";

const ProfileLoader = () => {
    return (
        <div className="grid grid-cols-[1fr_3fr] min-h-svh w-full gap-[10px]">
            <div className="flex flex-col gap-[2px] w-full">
              <div className="flex flex-col gap-4 w-full bg-white p-2 rounded-[4px]">
                <div className="w-full h-56 bg-gray-300 animate-pulse"></div>
                <div className="rounded-full w-48 h-6 bg-gray-300 animate-pulse"></div>
                <div className="rounded-full w-64 h-2 bg-gray-300 animate-pulse"></div>
              </div>
              <div className="w-full p-2 bg-white rounded-[4px]">
                <div className="flex justify-between w-full py-3">
                  <div className="rounded-full w-44 h-4 bg-gray-300 animate-pulse"></div>
                  <div className="rounded-full w-4 h-4 bg-gray-300 animate-pulse"></div>
                </div>
              </div>
              <div className="w-full p-2 bg-white rounded-[4px]">
                <div className="flex flex-col w-full gap-2 py-3">
                  <div className="rounded-full w-36 h-2 bg-gray-300 animate-pulse"></div>
                  <div className="rounded-full w-12 h-4 bg-gray-300 animate-pulse"></div>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center h-full w-full pt-48 bg-white rounded-[4px]">
              <Miniloader invert/>
            </div>
        </div>
    )
}

export { ProfileLoader };